import React, { Component } from "react";
import CenterLayout from "../../layout/center/CenterLayout";
import BorderLayout from "../../layout/border/BorderLayout";

export default class BorderLayoutDemo extends Component {
  render() {
    return (
      <BorderLayout
        items={{
          north: {
            el: <CenterLayout className="bg1">north</CenterLayout>,
            height: 100
          },
          south: {
            el: <CenterLayout className="bg2">south</CenterLayout>,
            height: 100
          },
          west: {
            el: <CenterLayout className="bg3">west</CenterLayout>,
            width: 100
          },
          east: {
            el: <CenterLayout className="bg4">east</CenterLayout>,
            width: 100
          },
          center: {
            el: <CenterLayout>center</CenterLayout>
          }
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/layout/demo.borderLayout.js